export type { M75MediaTextProps } from './M75MediaText';
export { M75MediaText } from './M75MediaText';
export { M75MediaText as default } from './M75MediaText';
